import * as React from "react";

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} viewBox="0 0 64 64" {...props}>
      {/* Light Bulb Base */}
      <rect x="26" y="50" width="12" height="6" rx="2" fill="#d3d3d3" />
      <rect x="24" y="56" width="16" height="6" rx="3" fill="#b3b3b3" />

      {/* Light Bulb Shape */}
      <path
        d="M32 10c-8 0-14 6-14 14 0 5 3 9 7 12v4h14v-4c4-3 7-7 7-12 0-8-6-14-14-14z"
        fill="#ffd55a"
        stroke="#000"
        strokeWidth="1.5"
      />

      {/* Gear */}
      <g transform="translate(38, 22)">
        <circle cx="0" cy="0" r="6" fill="#6c757d" />
        <path
          d="M-6 0h3M6 0h-3M0-6v3M0 6v-3"
          stroke="#000"
          strokeWidth="1.5"
        />
        <path
          d="M-4.2-4.2l2.1 2.1M4.2 4.2l-2.1-2.1M-4.2 4.2l2.1-2.1M4.2-4.2l-2.1 2.1"
          stroke="#000"
          strokeWidth="1.5"
        />
      </g>

      {/* Circuit Lines */}
      <line x1="32" y1="30" x2="32" y2="40" stroke="#000" strokeWidth="2" />
      <circle cx="28" cy="36" r="2" fill="#000" />
      <circle cx="36" cy="36" r="2" fill="#000" />
    </svg>
  );
}

export default SvgComponent;
